import { useMutation, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { layoffService } from '_services';
import {
  getErrorMessage,
  getFieldErrors,
  retryServerErrors,
} from '../useLayoff';

// Kept outside the ['layoffs'] keys so signing doesn't release the lock before the
// employee has seen the confirmation
export const noticeKeys = {
  active: ['layoff-lock'],
  detail: (hash) => ['layoff-notice', hash],
  preview: (hash, draft) => ['layoff-notice', 'preview', hash, draft],
};

export const useActiveNotice = (enabled = true) =>
  useQuery(noticeKeys.active, layoffService.getActiveNotice, {
    enabled,
    retry: 1,
    refetchOnWindowFocus: true,
  });

export const useNotice = (hash) =>
  useQuery(noticeKeys.detail(hash), () => layoffService.getNotice(hash), {
    enabled: !!hash,
    retry: retryServerErrors,
  });

export const useNoticePreview = (hash, draft, enabled = true) =>
  useQuery(
    noticeKeys.preview(hash, draft),
    () => layoffService.getNoticePreview({ hash, draft }),
    {
      enabled: !!hash && enabled,
      keepPreviousData: true,
      staleTime: 5 * 60 * 1000,
    },
  );

export const useSignNotice = ({ onSuccess, onError } = {}) =>
  useMutation(layoffService.signNotice, {
    onSuccess: (data, variables) => {
      toast.success(data.message);
      onSuccess?.(data, variables);
    },
    onError: (error, variables) => {
      // Field errors are shown next to the fields
      if (!getFieldErrors(error)) {
        toast.error(getErrorMessage(error));
      }
      onError?.(error, variables);
    },
  });
